import React from 'react';
import { Redirect } from 'react-router-dom';

function NotFoundPage() {
  return <Redirect to="/" />;
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/index.js